var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_vm._v(" Component 시험 페이지")]),_c('div',{staticClass:"chart_Layout"},[_c('Bar',{attrs:{"chart-options":_vm.options,"chart-data":_vm.chartData,"height":200}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }